<template>
  <div>
    <div v-if="showMessageSender" :class="messageSenderClasses">{{ senderName }}</div>
  </div>
</template>

<script>
// @flow

import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    message: {
      type: Object, // ChatBubbleMessage<TextContent>
      default: () => {
      }
    }
  },
  data: () => {
    return {
      checkedAttributes: []
    }
  },
  computed: {
    ...mapState(['customerId']),
    ...mapGetters(['latestMessage', 'latestMessageFromUser', 'latestMessageFromBot', 'avatarName']),
    isFromSubscriber (): boolean {
      return this.customerId === this.message.to
    },
    isLatestMessage (): boolean {
      return this.latestMessage && this.latestMessage.id === this.message.id
    },
    showMessageSender (): boolean {
      return this.isAvatarNameDefined && this.isLastMessageFromSender
    },
    isAvatarNameDefined (): boolean {
      return !!this.avatarName
    },
    isLastMessageFromSender (): boolean {
      return this.isLatestMessage || this.latestMessageFromUser?.id === this.message.id || this.latestMessageFromBot?.id === this.message.id
    },
    messageSenderClasses (): Object {
      return {
        'message-sender': true,
        'message-sender--from-bot': !this.isFromSubscriber,
        'message-sender--from-user': this.isFromSubscriber
      }
    },
    senderName (): string {
      if (this.isFromSubscriber) return this.$t('chatbot.you')

      return this.avatarName
    }
  }
}
</script>

<style src="./message-sender.scss" />
